var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          ref: "header",
          staticClass: "top-k",
          class: {
            " white-bg":
              (_vm.isBgWhite && !_vm.isPhoneSize) || _vm.$route.name != "Home",
            zindexTop: _vm.isPhoneSize
          },
          style: _vm.$route.name == "Enterprise" ? "width: 100%" : ""
        },
        [
          _vm.isPhoneSize
            ? _c(
                "span",
                {
                  staticClass: "logo-name iphone",
                  attrs: { id: "head_span_goHome_iphone" },
                  on: {
                    click: function($event) {
                      _vm.navtop_comm("logo")
                      _vm.goHome()
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      src: require("@/assets/images/newlogo/logo.svg"),
                      alt: ""
                    }
                  })
                ]
              )
            : _c(
                "span",
                {
                  staticClass: "logo-name",
                  attrs: { id: "head_span_goHome_logo-name" },
                  on: {
                    click: function($event) {
                      _vm.navtop_comm("logo")
                      _vm.goHome()
                    }
                  }
                },
                [
                  !_vm.isBgWhite && _vm.$route.name == "Home"
                    ? _c("img", {
                        staticStyle: { width: "420px" },
                        attrs: {
                          src: require("@/assets/images/newlogo/whitelogo.svg"),
                          alt: ""
                        }
                      })
                    : _c("img", {
                        staticStyle: { width: "420px" },
                        attrs: {
                          src: require("@/assets/images/newlogo/logo.svg"),
                          alt: ""
                        }
                      })
                ]
              ),
          _vm._v(" "),
          _vm.isPhoneSize
            ? _c("div", { staticClass: "right-user" }, [
                _c("i", {
                  staticClass: "iconfont icontel",
                  attrs: { id: "head_i_tel_app", "data-agl-cvt": "2" },
                  on: {
                    click: function($event) {
                      _vm.tel()
                      _vm.call_navtop()
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "iconfont iconmenu",
                  attrs: { id: "head_i_rightmenu_iconmenu" },
                  on: {
                    click: function($event) {
                      _vm.rightmenu = true
                      _vm.navigatorTop("burger open")
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(_vm.rightmenu && _vm.isPhoneSize),
                  expression: "!(rightmenu && isPhoneSize)"
                }
              ],
              staticClass: "menu"
            },
            [
              _c(
                "a",
                {
                  class: { active: _vm.activeIndex == 1 },
                  attrs: {
                    id: "head_a_menulink_active",
                    href: "https://www.byepest.com/"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.menulink("/")
                    }
                  }
                },
                [_vm._v("品牌与服务")]
              ),
              _vm._v("|\n      "),
              _c(
                "a",
                {
                  class: { active: _vm.activeIndex == 5 },
                  attrs: { id: "head_a_menulink_1", href: "javascript:;" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.menulink("/pest_wiki")
                    }
                  }
                },
                [_vm._v("虫害百科")]
              ),
              _vm._v("|\n      "),
              _c(
                "a",
                {
                  attrs: { id: "head_a_menulink_2", href: "javascript:;" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.codeModalShow = true
                    }
                  }
                },
                [_vm._v("虫虫社区")]
              ),
              _vm._v("|\n      "),
              _c(
                "a",
                {
                  attrs: { id: "head_a_menulink_3", href: "javascript:;" },
                  on: {
                    click: function($event) {
                      return _vm.weixinLink()
                    }
                  }
                },
                [_vm._v("个人中心")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.isPhoneSize && _vm.rightLogin
        ? _c("div", {
            staticClass: "bggray-mask",
            attrs: { id: "head_div_rightLogin_bggray-mask" },
            on: {
              click: function($event) {
                _vm.rightLogin = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "右侧菜单",
            visible: _vm.rightmenu,
            direction: _vm.isPhoneSize ? "ttb" : "rtl",
            size: "100vh",
            "custom-class": "rightmenu-k",
            "with-header": false
          },
          on: {
            "update:visible": function($event) {
              _vm.rightmenu = $event
            }
          }
        },
        [
          _c("div", { staticClass: "closeright" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/newhome/close.svg"),
                alt: ""
              },
              on: {
                click: function($event) {
                  _vm.rightmenu = false
                  _vm.navigatorTop("burger close")
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "menu-k" }, [
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.linkhome()
                  }
                }
              },
              [
                _vm._v("\n          品牌与服务\n          "),
                _c("p", [_vm._v("HOME & ABOUT")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.wikiLink()
                  }
                }
              },
              [
                _vm._v("\n          虫害百科\n          "),
                _c("p", [_vm._v("PEST WIKIPEDIA")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    _vm.rightmenu = false
                    _vm.codeModalShow = true
                  }
                }
              },
              [
                _vm._v("\n          虫虫社区\n          "),
                _c("p", [_vm._v("BYEPEST COMMUNITY")])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.weixinLink()
                  }
                }
              },
              [
                _vm._v("\n          个人中心\n          "),
                _c("p", [_vm._v("MY SERVICES")])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "contact-dialog-tip",
          attrs: { title: "立即咨询", visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("立即咨询")]),
          _vm._v(" "),
          _c("span", { staticClass: "contact-warn" }, [
            _vm._v(
              "小拜正在奋力敲代码中，点击下方热线电话，小拜将为您匹配专属顾问提供服务~"
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "a",
              {
                staticClass: "cancle",
                attrs: {
                  id: "head_a_dialogVisible_cancle",
                  href: "javascript:;"
                },
                on: {
                  click: function($event) {
                    _vm.dialogVisible = false
                  }
                }
              },
              [_vm._v("取消")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btnfoot",
                attrs: { id: "head_a_tel_btnfoot", href: "tel:4001888282" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.tel()
                  }
                }
              },
              [
                _c("i", { staticClass: "iconfont icontel1" }),
                _vm._v("热线电话")
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isPhoneSize
        ? _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.kefuShow,
                size: "80%",
                "with-header": false,
                direction: "btt"
              },
              on: {
                "update:visible": function($event) {
                  _vm.kefuShow = $event
                }
              }
            },
            [
              _c("iframe", {
                ref: "myframe",
                attrs: {
                  src: _vm.iframeUrl,
                  frameborder: "0",
                  scrolling: "auto",
                  marginheight: "0",
                  marginwidth: "0",
                  width: "100%",
                  height: "100%"
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.name != "CustomerCenterSet" && _vm.$route.name != "ccbbC"
        ? _c("div", { staticClass: "right-bottom-tel" }, [
            _c(
              "i",
              {
                staticClass: "iconfont icontel-p",
                attrs: { id: "head_i_talk_icontel_p" },
                on: {
                  click: function($event) {
                    return _vm.telxuan()
                  }
                }
              },
              [_c("span", [_vm._v("电话")])]
            ),
            _vm._v(" "),
            _c(
              "i",
              {
                staticClass: "iconfont icontel1",
                attrs: { id: "head_i_talk_icontel1" },
                on: {
                  click: function($event) {
                    return _vm.talk()
                  }
                }
              },
              [_c("span", [_vm._v("客服")])]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "weixin-dialog-get",
          attrs: {
            title: "打开微信搜索 拜耳虫虫拜拜 公众号",
            top: "20vh",
            visible: _vm.weixinDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.weixinDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "pw" }, [
            _c("i", { staticClass: "iconfont iconweixin" }, [
              _vm._v("微信搜一搜")
            ]),
            _vm._v(" "),
            _c("span", [
              _c("i", { staticClass: "iconfont iconsearch" }),
              _vm._v("拜耳虫虫拜拜")
            ])
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "tips" }, [
            _vm._v("关注公众号防走丢 轻松获取更多信息咨询")
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  return _vm.copyAndOpen("拜耳虫虫拜拜")
                }
              }
            },
            [_vm._v("复制并打开微信")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.codeModalShow ? "code-modal show" : "code-modal" },
        [
          _c("div", { staticClass: "close" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/newhome/closew.svg"),
                alt: ""
              },
              on: {
                click: function($event) {
                  _vm.codeModalShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("h3", [
              _vm._v("虫虫拜拜邀请您"),
              _vm.isPhoneSize ? _c("br") : _vm._e(),
              _vm._v("加入虫虫社区")
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "weixin-dialog-img",
          attrs: { title: "", top: "20vh", visible: _vm.weixinDialogImg },
          on: {
            "update:visible": function($event) {
              _vm.weixinDialogImg = $event
            }
          }
        },
        [
          _vm.codeImgd == ""
            ? _c("div", { staticClass: "con" }, [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: require("@/assets/images/newhome/404.png"),
                      expression: "require('@/assets/images/newhome/404.png')"
                    }
                  ],
                  staticStyle: { width: "50%", height: "auto" }
                }),
                _vm._v(" "),
                _c("p", { staticStyle: { color: "#4D4CC1" } }, [
                  _vm._v("服务即将上线，敬请期待")
                ])
              ])
            : _c("div", { staticClass: "con" }, [
                _c("img", {
                  directives: [
                    {
                      name: "lazy",
                      rawName: "v-lazy",
                      value: require("@/assets/images/newhome/" +
                        _vm.codeImgd +
                        ".png"),
                      expression:
                        "require('@/assets/images/newhome/' + codeImgd + '.png')"
                    }
                  ]
                }),
                _vm._v(" "),
                _c("p", [_vm._v("请微信扫码查看相关详情")])
              ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/newhome/codesq.png"), alt: "" }
      }),
      _vm._v("长按图片保存")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8d4ebe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8d4ebe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Head.vue
// module id = null
// module chunks = 